import {Formik} from "formik";
import ProfileBanner from "../../components/Profile/Banner";
import * as yup from "yup";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";

const PasswordPage = () => {
  const {onUpdatePassword} = useUpdateTechnician();
  const schema = yup.object().shape({
    currentPassword: yup.string().required("Champ obligatoire"),
    newPassword: yup
      .string()
      .required("Champ obligatoire")
      .min(8, "Le nouveau mot de passe doit contenir au moins 8 caractères")
      .max(128, "Le nouveau mot de passe doit contenir au maximum 128 caractères")
      .matches(/[a-z]/, "Le mot de passe doit contenir au moins une minuscule")
      .matches(/[A-Z]/, "Le mot de passe doit contenir au moins une majuscule")
      .matches(/\d/, "Le mot de passe doit contenir au moins un chiffre"),
    confirmNewPassword: yup
      .string()
      .oneOf(
        [yup.ref("newPassword"), null],
        "Les mots de passe doivent correspondre"
      )
      .required("Champ obligatoire"),
  });

  return (
    <>
      <div className="w-full flex flex-col px-1 lg:grid lg:grid-cols-4 gap-4">
        <ProfileBanner modifProfile={true} />

        <div className="col-span-4 w-full">
          <div className="card">
            <div className="card-body">
              <div className="flex w-full xl:w-1/2 flex-col justify-start">
                <Formik
                  initialValues={{
                    currentPassword: "",
                    newPassword: "",
                    confirmNewPassword: "",
                  }}
                  validationSchema={schema}
                  onSubmit={(values, {setSubmitting}) => {
                    const {currentPassword, newPassword} = values;
                    onUpdatePassword({
                      newPassword: newPassword,
                      oldPassword: currentPassword,
                    });

                    setSubmitting(false);
                  }}
                >
                  {({
                    values,
                    errors,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    touched,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <h3 className="text-left  font-semibold  text-xl leading-9">
                        Modifiez mon mot de passe
                      </h3>

                      {/*  {props.errorMessage && (
                        <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
                          {props.errorMessage}
                        </div>
                      )}
                      {props.successMessage && (
                        <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                          {props.successMessage}
                        </div>
                      )} */}
                      <div className="w-full p-2 lg:p-5">
                        <div className="form-group">
                          <label className=" text-sm  text-[#7E7E7E]">
                            Mot de passe actuel
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            name="currentPassword"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.currentPassword}
                          />
                          {touched.currentPassword &&
                            errors.currentPassword && (
                              <div
                                className="invalid-feedback animated fadeInUp"
                                style={{display: "block"}}
                              >
                                {errors.currentPassword}
                              </div>
                            )}
                        </div>

                        <div className="form-group">
                          <label className=" text-sm  text-[#7E7E7E]">
                            Nouveau mot de passe
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            name="newPassword"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.newPassword}
                          />
                          {touched.newPassword && errors.newPassword && (
                            <div
                              className="invalid-feedback animated fadeInUp"
                              style={{display: "block"}}
                            >
                              {errors.newPassword}
                            </div>
                          )}
                        </div>

                        <div className="form-group">
                          <label className=" text-sm  text-[#7E7E7E]">
                            Confirmer le nouveau mot de passe
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            name="confirmNewPassword"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.confirmNewPassword}
                          />
                          {touched.confirmNewPassword &&
                            errors.confirmNewPassword && (
                              <div
                                className="invalid-feedback animated fadeInUp"
                                style={{display: "block"}}
                              >
                                {errors.confirmNewPassword}
                              </div>
                            )}
                        </div>

                        <div className="text-center mt-4">
                          <button
                            disabled={isSubmitting}
                            type="submit"
                            className="btn !rounded-lg text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] btn-block uppercase"
                          >
                            Enregistrer
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PasswordPage;
